(function () {
  'use strict';

  var DESK = window.matchMedia('(min-width: 1100px)');
  var PHONE = window.matchMedia('(max-width: 767px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea, [tabindex]';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }
  function focusables(ctx) {
    return $$(FOCUSABLE, ctx).filter(function (el) { return el.getAttribute('tabindex') !== '-1' && visible(el); });
  }
  function listen(el, type, fn, list, opts) {
    el.addEventListener(type, fn, opts || false);
    list.push(function () { el.removeEventListener(type, fn, opts || false); });
  }
  function listenMQ(mq, fn, list) {
    if (mq.addEventListener) { mq.addEventListener('change', fn); list.push(function () { mq.removeEventListener('change', fn); }); }
    else if (mq.addListener) { mq.addListener(fn); list.push(function () { mq.removeListener(fn); }); }
  }

  function Header(root) {
    this.root = root;
    this.bar = $('[data-teh-bar]', root);
    this.ph = $('[data-teh-ph]', root);
    this.input = $('[data-teh-search]', root);
    this.off = [];
    this.timers = {};
    this.openId = null;
    this.lastTrigger = null;
    this.condensed = false;
    this.rail = null;
    root.teHeader = this;
    this.initDropdowns();
    this.initPopovers();
    this.initCondense();
    this.initRail();
    this.initChips();
    this.initSearch();
    this.initShipping();
    this.initCartCount();
    if (this.bar) this.bar.classList.add('site-header--sticky');
    var self = this;
    listenMQ(DESK, function () { self.closeDrop(); self.closePops(); if (DESK.matches) self.closeRail(true); self.updatePlaceholder(); }, this.off);
    listenMQ(PHONE, function () { self.updatePlaceholder(); }, this.off);
  }

  Header.prototype.initDropdowns = function () {
    var self = this;
    this.triggers = $$('[data-teh-trigger]', this.root);
    this.panels = $$('[data-teh-panel]', this.root);
    this.triggers.forEach(function (t) {
      var id = t.getAttribute('data-teh-trigger');
      listen(t, 'pointerenter', function (e) { if (e.pointerType === 'mouse') self.openSoon(id, t); }, self.off);
      listen(t, 'pointerleave', function (e) { if (e.pointerType === 'mouse') self.closeSoon(); }, self.off);
      listen(t, 'click', function (e) {
        e.preventDefault();
        self.clearTimers();
        if (self.openId === id) self.closeDrop(); else self.openDrop(id, t);
      }, self.off);
      listen(t, 'keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); self.openDrop(id, t); self.focusPanel(id); }
        else if (e.key === 'Escape' && self.openId) { self.closeDrop(); t.focus(); }
        else if (e.key === 'Tab' && !e.shiftKey && self.openId === id) {
          if (self.focusPanel(id)) e.preventDefault();
        }
      }, self.off);
    });
    this.panels.forEach(function (p) {
      listen(p, 'pointerenter', function (e) { if (e.pointerType === 'mouse') clearTimeout(self.timers.c); }, self.off);
      listen(p, 'pointerleave', function (e) { if (e.pointerType === 'mouse') self.closeSoon(); }, self.off);
      listen(p, 'keydown', function (e) {
        var t = self.lastTrigger;
        if (e.key === 'Escape') { self.closeDrop(); if (t) t.focus(); return; }
        if (e.key !== 'Tab' || !t) return;
        var f = focusables(p);
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); t.focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) {
          e.preventDefault();
          self.closeDrop();
          self.focusAfter(t);
        }
      }, self.off);
    });
    listen(document, 'pointerdown', function (e) {
      if (self.openId && !self.bar.contains(e.target)) self.closeDrop();
    }, this.off);
    listen(this.bar, 'focusout', function (e) {
      if (self.openId && e.relatedTarget && !self.bar.contains(e.relatedTarget)) self.closeDrop();
    }, this.off);
  };
  Header.prototype.initChips = function () {
    var wrap = $('[data-teh-chips]', this.root);
    if (!wrap) return;
    var sc = $('.teh-chips', wrap);
    var more = $('.teh-chips-more', wrap);
    if (!sc) return;
    function update() {
      var max = sc.scrollWidth - sc.clientWidth;
      wrap.classList.toggle('is-more', max > 2 && sc.scrollLeft < max - 2);
      wrap.classList.toggle('is-scrolled', sc.scrollLeft > 2);
    }
    var cur = $('[aria-current="page"]', sc);
    if (cur && PHONE.matches && cur.parentNode) {
      var li = cur.parentNode;
      var pin = $('li', sc);
      if (li !== pin && li.offsetLeft + li.offsetWidth > sc.clientWidth - 52) sc.scrollLeft = li.offsetLeft - (pin ? pin.offsetWidth : 0) - 8;
    }
    update();
    if (wrap.classList.contains('is-more') && !REDUCED.matches) {
      wrap.classList.add('is-nudge');
      var t = setTimeout(function () { wrap.classList.remove('is-nudge'); }, 6500);
      this.off.push(function () { clearTimeout(t); });
    }
    listen(sc, 'scroll', update, this.off, { passive: true });
    listen(window, 'resize', update, this.off, { passive: true });
    listen(window, 'load', update, this.off);
    listenMQ(PHONE, update, this.off);
    if (more) {
      listen(more, 'click', function () {
        sc.scrollBy({ left: Math.max(120, Math.round(sc.clientWidth * 0.7)), behavior: REDUCED.matches ? 'auto' : 'smooth' });
      }, this.off);
    }
  };
  Header.prototype.clearTimers = function () { clearTimeout(this.timers.o); clearTimeout(this.timers.c); };
  Header.prototype.openSoon = function (id, t) {
    var self = this;
    this.clearTimers();
    this.timers.o = setTimeout(function () { self.openDrop(id, t); }, this.openId ? 40 : 140);
  };
  Header.prototype.closeSoon = function () {
    var self = this;
    this.clearTimers();
    this.timers.c = setTimeout(function () { self.closeDrop(); }, 240);
  };
  Header.prototype.openDrop = function (id, trigger) {
    if (!DESK.matches) return;
    this.closePops();
    this.panels.forEach(function (p) { p.hidden = p.getAttribute('data-teh-panel') !== id; });
    this.triggers.forEach(function (t) { t.setAttribute('aria-expanded', t.getAttribute('data-teh-trigger') === id ? 'true' : 'false'); });
    this.openId = id;
    if (trigger) this.lastTrigger = trigger;
  };
  Header.prototype.closeDrop = function () {
    this.clearTimers();
    if (!this.openId) return;
    this.panels.forEach(function (p) { p.hidden = true; });
    this.triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    this.openId = null;
  };
  Header.prototype.focusPanel = function (id) {
    var p = $('[data-teh-panel="' + id + '"]', this.root);
    var f = p ? focusables(p)[0] : null;
    if (f) f.focus();
    return !!f;
  };
  Header.prototype.focusAfter = function (el) {
    var all = focusables(document).filter(function (x) { return !x.closest('[data-teh-panel]'); });
    var i = all.indexOf(el);
    if (i > -1 && all[i + 1]) all[i + 1].focus();
  };

  Header.prototype.initPopovers = function () {
    var self = this;
    this.pops = $$('[data-teh-pop]', this.root);
    this.pops.forEach(function (btn) {
      var pop = document.getElementById(btn.getAttribute('aria-controls'));
      if (!pop) return;
      listen(btn, 'click', function () {
        var wasOpen = btn.getAttribute('aria-expanded') === 'true';
        self.closePops();
        self.closeDrop();
        if (!wasOpen) { pop.hidden = false; btn.setAttribute('aria-expanded', 'true'); }
      }, self.off);
      var esc = function (e) { if (e.key === 'Escape') { self.closePops(); btn.focus(); } };
      listen(btn, 'keydown', esc, self.off);
      listen(pop, 'keydown', esc, self.off);
      listen(btn.parentNode, 'focusout', function (e) {
        if (e.relatedTarget && !btn.parentNode.contains(e.relatedTarget)) self.closePops();
      }, self.off);
    });
    listen(document, 'pointerdown', function (e) {
      self.pops.forEach(function (btn) {
        if (btn.getAttribute('aria-expanded') === 'true' && !btn.parentNode.contains(e.target)) self.closePops();
      });
    }, this.off);
  };
  Header.prototype.closePops = function () {
    (this.pops || []).forEach(function (btn) {
      var pop = document.getElementById(btn.getAttribute('aria-controls'));
      if (pop) pop.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    });
  };

  Header.prototype.initCondense = function () {
    var self = this;
    var sentinel = $('[data-teh-sentinel]', this.root);
    if (!sentinel || !this.bar || !this.ph || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      self.setCondensed(!e.isIntersecting && e.boundingClientRect.top < 0);
    });
    io.observe(sentinel);
    this.off.push(function () { io.disconnect(); });
  };
  Header.prototype.setCondensed = function (on) {
    if (on === this.condensed) return;
    this.closeDrop();
    this.closePops();
    if (on) {
      this.ph.style.height = this.bar.offsetHeight + 'px';
      this.root.classList.add('is-condensed');
    } else {
      this.root.classList.remove('is-condensed');
      this.ph.style.height = '';
    }
    this.condensed = on;
    this.updatePlaceholder();
  };

  Header.prototype.initRail = function () {
    var self = this;
    this.openers = $$('[data-teh-open-rail]', this.root);
    this.openers.forEach(function (b) {
      listen(b, 'click', function () { self.openRail(b.getAttribute('data-teh-open-rail'), b); }, self.off);
    });
  };
  Header.prototype.buildRail = function () {
    if (this.rail) return this.rail;
    var tpl = $('template#TehRailTpl', this.root);
    if (!tpl || !tpl.content) return null;
    var dr = tpl.content.firstElementChild.cloneNode(true);
    this.root.appendChild(dr);
    this.rail = dr;
    this.openRow = null;
    this.rows = $$('[data-teh-row]', dr);
    var self = this;
    this.rows.forEach(function (r) {
      listen(r, 'click', function () { self.toggleRow(r.getAttribute('data-teh-row')); }, self.off);
    });
    var body = $('[data-teh-rail-body]', dr);
    var more = $('[data-teh-rail-more]', dr);
    var onRailScroll = function () { self.updateRailMore(); };
    if (body) listen(body, 'scroll', onRailScroll, this.off, { passive: true });
    listen(window, 'resize', onRailScroll, this.off, { passive: true });
    if (body && more) {
      listen(more, 'click', function () {
        body.scrollBy({ top: Math.max(120, Math.round(body.clientHeight * 0.7)), behavior: REDUCED.matches ? 'auto' : 'smooth' });
      }, this.off);
    }
    this.off.push(function () { clearTimeout(self.timers.nudge); });
    $$('[data-teh-close]', dr).forEach(function (b) { listen(b, 'click', function () { self.closeRail(); }, self.off); });
    var search = $('[data-teh-rail-search]', dr);
    if (search) {
      listen(search, 'click', function () {
        self.closeRail(true);
        if (self.input) self.input.focus();
      }, this.off);
    }
    listen(dr, 'keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.closeRail(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(dr);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }, this.off);
    $$('[data-teh-currency-rail] select', dr).forEach(function (sel) {
      listen(sel, 'change', function () { if (sel.form) sel.form.submit(); }, self.off);
    });
    return dr;
  };
  Header.prototype.hasRow = function (id) {
    return !!id && (this.rows || []).some(function (r) { return r.getAttribute('data-teh-row') === id; });
  };
  Header.prototype.toggleRow = function (id) {
    this.expandRow(this.openRow === id ? null : id, false);
  };
  Header.prototype.expandRow = function (id, toTop) {
    var dr = this.rail;
    var on = null;
    (this.rows || []).forEach(function (r) {
      var me = r.getAttribute('data-teh-row') === id;
      r.setAttribute('aria-expanded', me ? 'true' : 'false');
      var p = document.getElementById(r.getAttribute('aria-controls'));
      if (p) p.hidden = !me;
      if (me) on = r;
    });
    this.openRow = on ? id : null;
    var body = dr ? $('[data-teh-rail-body]', dr) : null;
    if (on && toTop && body) body.scrollTop = Math.max(0, on.offsetTop - 8);
    if (dr && !dr.hidden) {
      this.updateRailMore();
      if (on) this.nudgeRailMore();
    }
  };
  Header.prototype.updateRailMore = function () {
    var dr = this.rail;
    if (!dr) return;
    var body = $('[data-teh-rail-body]', dr);
    var more = $('[data-teh-rail-more]', dr);
    if (more) more.classList.toggle('is-on', !!body && body.scrollHeight - body.clientHeight - body.scrollTop > 2);
  };
  Header.prototype.nudgeRailMore = function () {
    var dr = this.rail;
    var b = dr ? $('[data-teh-rail-more]', dr) : null;
    if (!b || REDUCED.matches) return;
    b.classList.remove('is-nudge');
    if (!b.classList.contains('is-on')) return;
    void b.offsetWidth;
    b.classList.add('is-nudge');
    clearTimeout(this.timers.nudge);
    this.timers.nudge = setTimeout(function () { b.classList.remove('is-nudge'); }, 6500);
  };
  Header.prototype.openRail = function (tab, opener) {
    if (DESK.matches) return;
    var dr = this.buildRail();
    if (!dr) return;
    this.closePops();
    this.opener = opener || document.activeElement;
    clearTimeout(this.timers.rail);
    document.documentElement.classList.add('teh-lock');
    dr.hidden = false;
    var body = $('[data-teh-rail-body]', dr);
    if (body) body.scrollTop = 0;
    this.expandRow(this.hasRow(tab) ? tab : null, true);
    void dr.offsetWidth;
    dr.classList.add('is-open');
    this.updateRailMore();
    this.nudgeRailMore();
    this.openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var target = (this.openRow && $('[data-teh-row="' + this.openRow + '"]', dr)) || $('[data-teh-rail-search]', dr);
    if (target) setTimeout(function () { target.focus({ preventScroll: true }); }, 40);
  };
  Header.prototype.closeRail = function (noFocus) {
    var dr = this.rail;
    if (!dr || dr.hidden) return;
    dr.classList.remove('is-open');
    document.documentElement.classList.remove('teh-lock');
    this.openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    this.timers.rail = setTimeout(function () { dr.hidden = true; }, REDUCED.matches ? 0 : 300);
    if (!noFocus && this.opener && document.contains(this.opener)) this.opener.focus({ preventScroll: true });
  };

  Header.prototype.initSearch = function () {
    var input = this.input;
    if (!input) return;
    var self = this;
    this.updatePlaceholder();
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { self.updatePlaceholder(); });
      mo.observe(input, { attributes: true, attributeFilter: ['placeholder'] });
      this.off.push(function () { mo.disconnect(); });
    }
  };
  Header.prototype.updatePlaceholder = function () {
    var input = this.input;
    if (!input) return;
    var want = input.getAttribute(DESK.matches ? 'data-ph-desk' : 'data-ph-short');
    if (want && PHONE.matches && this.condensed) {
      want = want.split(',')[0];
      if (window.innerWidth < 375) want = want.split(' ')[0];
    }
    if (want && input.getAttribute('placeholder') !== want) input.setAttribute('placeholder', want);
  };

  Header.prototype.initShipping = function () {
    var root = this.root;
    if (!root.hasAttribute('data-teh-ship-live')) return;
    var threshold = parseInt(root.getAttribute('data-teh-threshold'), 10) || 12000;
    var fmt = null;
    try { fmt = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', currencyDisplay: 'narrowSymbol' }); } catch (e) { fmt = null; }
    var money = function (cents) { var a = cents / 100; return (fmt ? fmt.format(a) : '$' + a.toFixed(2)) + ' CAD'; };
    var render = function (cart) {
      if (!cart || cart.currency !== 'CAD') return;
      var state = cart.item_count > 0 ? (cart.total_price >= threshold ? 'qualified' : 'progress') : 'default';
      $$('[data-teh-ship-state]', root).forEach(function (el) { el.hidden = el.getAttribute('data-teh-ship-state') !== state; });
      $$('[data-teh-ship-remaining]', root).forEach(function (el) { el.textContent = money(Math.max(threshold - cart.total_price, 0)); });
    };
    var timer = null;
    var refresh = function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(base + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(render)
          .catch(function () {});
      }, 150);
    };
    if ('PerformanceObserver' in window) {
      try {
        var po = new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (entry) {
            if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(entry.name)) refresh();
          });
        });
        po.observe({ type: 'resource' });
        this.off.push(function () { po.disconnect(); });
      } catch (e) {}
    }
    var self = this;
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (name) { listen(document, name, refresh, self.off); });
    listen(window, 'pageshow', function (e) { if (e.persisted) refresh(); }, this.off);
  };

  Header.prototype.initCartCount = function () {
    var badge = $('.teh-cart-count', this.root);
    if (!badge || !('MutationObserver' in window)) return;
    var link = badge.closest('a');
    var sync = function () {
      var n = parseInt(badge.textContent, 10) || 0;
      badge.classList.toggle('is-empty', n === 0);
      if (link) link.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    };
    var mo = new MutationObserver(sync);
    mo.observe(badge, { childList: true, characterData: true, subtree: true });
    this.off.push(function () { mo.disconnect(); });
  };

  Header.prototype.selectBlock = function (el) {
    var tab = el.getAttribute('data-teh-tab');
    if (!tab) return;
    if (DESK.matches) { if ($('[data-teh-panel="' + tab + '"]', this.root)) this.openDrop(tab, $('[data-teh-trigger="' + tab + '"]', el)); }
    else this.openRail(tab);
  };
  Header.prototype.destroy = function () {
    this.closeRail(true);
    document.documentElement.classList.remove('teh-lock');
    this.clearTimers();
    this.off.forEach(function (fn) { fn(); });
    this.off = [];
    if (this.rail && this.rail.parentNode) this.rail.parentNode.removeChild(this.rail);
    this.root.teHeader = null;
  };

  function init(scope) {
    $$('[data-teh-header]', scope).forEach(function (root) { if (!root.teHeader) new Header(root); });
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    $$('[data-teh-header]', e.target).forEach(function (root) { if (root.teHeader) root.teHeader.destroy(); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-teh-header]');
    if (root && root.teHeader) root.teHeader.selectBlock(e.target);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest && e.target.closest('[data-teh-header]');
    if (root && root.teHeader) { root.teHeader.closeDrop(); root.teHeader.closeRail(true); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
